import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import DownloadIcon from '@mui/icons-material/Download';
import FlagstoneTheme from '../../config/flagstoneTheme';
import DeleteIcon from '@mui/icons-material/Delete';
import MessageDialog from '../../base/dialogs/messageDialog';
import { dataService } from '../../services/data/data.service';
import { Link } from 'react-router-dom'

export default function FileOverviewPage(props) {
    const classes = useStyles();
    const [files, setFiles] = useState([])
    const [fileToDelete, setFileToDelete] = useState(null)
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false)

    useEffect(() => {
        getAllProcessedExcelFiles();
    }, [])
    const getAllProcessedExcelFiles = () => {
        dataService.getAllProcessedExcelFiles(props.user.userid).then(result => {
            if (result.data !== null && JSON.stringify(result.data) !== JSON.stringify(files)) {
                result.data.map(file => {
                    if (file.id === 0) {
                        var lastchars = ((file.name).substr((file.name).length - 19)).split('.')[0];
                        var date = new Date(lastchars.replace(
                            /^(\d{4})(\d\d)(\d\d)(\d\d)(\d\d)(\d\d)$/,
                            '$4:$5:$6 $2/$3/$1'
                        ))
                        var dd = String(date.getDate()).padStart(2, '0');
                        var mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
                        var yyyy = date.getFullYear();
                        var hh = date.getHours() < 10 ? '0'+ date.getHours() : date.getHours();
                        var min = date.getMinutes() < 10 ? '0'+ date.getMinutes() : date.getMinutes();

                        date = dd + '-' + mm + '-' + yyyy + ' ' + hh + ':' + min;
                        file.momentInsert = date;
                    }
                    file.date = new Date(file.momentInsert.split(" ").map(part => part.split("-").reverse().join("/")).join(" "));
                });
          
                setFiles(result.data.sort((a, b) =>  b.date - a.date));
            }
        })
    }

    const deleteFile = () => {
        setDeleteDialogOpen(false);
        dataService.deleteTransformedExcel(fileToDelete).then(() => {
            setReload(true);
            location.reload();

        }).catch((error) => {
            location.reload();

            console.log("failed deleting file row")
        });
    }

    const openDeleteDialog = (file) => {
        setFileToDelete(file);
        setDeleteDialogOpen(true);
    }

    const closeDeleteDialog = () => {
        setDeleteDialogOpen(false);
    }


    return (
        <div className={classes.container}>
            <div className={classes.title}>{"Verwerkte bestanden"}</div>
            <Table className={classes.table} aria-label="customized table">
                <TableHead>
                    <TableRow>
                        <TableCell className={classes.leftHeadCell} width={"70%"}>{"Bestand"}</TableCell>
                        <TableCell className={classes.headCell} width={"10%"} align="center">{"Datum"}</TableCell>
                        <TableCell className={classes.headCell} width={"10%"} align="center">{"Download"}</TableCell>
                        <TableCell className={classes.headCell} width={"10%"} align="center">{"Verwijder"}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {files.map((file) => (
                        <TableRow key={file.name} className={classes.row}>
                            <TableCell className={classes.leftCell}>{file.name}</TableCell>
                            <TableCell className={classes.midCell} align="center">{file.momentInsert}</TableCell>
                            <TableCell className={classes.midCell} align="center">
                                <Link to={'/processed/' + file.name} target="_blank" download><DownloadIcon className={classes.downloadIcon} disabled={!props.user.isInterCommunales}></DownloadIcon></Link>
                            </TableCell>
                            <TableCell className={classes.rightCell} align="center">
                                {!props.user.isInterCommunales ?
                                    <DeleteIcon className={classes.downloadIconDisabled} disabled={!props.user.isInterCommunales}></DeleteIcon>

                                    :
                                    <DeleteIcon className={classes.downloadIcon} onClick={() => openDeleteDialog(file.id)}></DeleteIcon>

                                }
                            </TableCell>
                        </TableRow>

                    ))}
                </TableBody>
            </Table>
            <MessageDialog
                messageTitle={"Verwijder bestand"}
                messageContent={"Bent u zeker dat u volgend bestand wilt verwijderen:" + fileToDelete}
                buttonText={"VERWIJDEREN"}
                button2Text={"ANNULEER"}
                action={deleteFile}
                closeDialog={closeDeleteDialog}
                dialogOpen={deleteDialogOpen}>
            </MessageDialog>
        </div>
    )

}

const useStyles = makeStyles(() => ({
    container: {
        height: 'calc(100vh - 205px)',
        padding: "50px"
    },
    title: {
        fontSize: "18px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        textAlign: "left",
        color: "#616A6E"
    },
    downloadIcon: {
        color: FlagstoneTheme.palette.primary.main,
        cursor: "pointer"
    },
    downloadIconDisabled: {
        color: "#cccccc",
        cursor: "not-allowed",
    },
    leftHeadCell: {
        fontSize: "16px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: "#616A6E",
        padding: "0px",
        paddingLeft: "20px",
        border: "none",
        height: "10px",
        lineHeight: "0px"
    },
    headCell: {
        fontSize: "16px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: "#616A6E",
        padding: "0px",
        border: "none",
        height: "10px",
        lineHeight: "0px"
    },
    leftCell: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        color: "#020100",
        padding: "10px",
        borderTop: "1px solid #DEDEDE",
        borderBottom: "1px solid #DEDEDE !important",
        borderLeft: "1px solid #DEDEDE",
        borderRadius: "6px 0 0 6px",
        backgroundColor: "white",
        paddingLeft: "20px",
    },
    midCell: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
        padding: "10px",
        paddingRight: "5px",
        paddingLeft: "0px",
        borderTop: "1px solid #DEDEDE",
        borderBottom: "1px solid #DEDEDE !important",
        backgroundColor: "white",
    },
    rightCell: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
        padding: "10px",
        borderTop: "1px solid #DEDEDE",
        borderBottom: "1px solid #DEDEDE !important",
        borderRight: "1px solid #DEDEDE",
        borderRadius: " 0 6px 6px 0",
        backgroundColor: "white",
        paddingRight: "10px",
        paddingLeft: "5px",
    },
    table: {
        borderSpacing: "0 5px !important",
        borderCollapse: "separate !important",
        width: "100%",
        marginTop: "30px"
    },
}));